/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import ContentHub from '@nmx/template/dist/componentLibrary/modules/ContentHub';
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
// native components
import AdvisorConnectModule from './components/advisorConnectModule';
import CredentialCalloutGrouping from './components/credentialCalloutGrouping';
import Faq from './components/faq';
import FinancialPlanningSection from './components/financialPlanningSection';
import HelpYouPlanSection from './components/helpYouPlanSection';
import HeroSection from './components/heroSection';
import IntroSection from './components/introSection/introSection';
import Metadata from './components/metadata';
// images
import highResDesktopImage from  './components/heroSection/images/college-savings-plans-hero-desktop.webp';
import highResMobileImage from './components/heroSection/images/college-savings-plans-hero-mobile.webp';
// disclaimer footnotes
import {
  LoyaltyBasedOnClientData,
  RankingNmInvestmentsServices,
} from '../../../utils/disclaimerFootnotes/disclaimerFootnotes';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps, contentHubItems } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      useReCaptcha={false}
      disableDisclaimerTopBorder
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Financial Planning',
          linkUrl: '/financial-planning/',
          linkAriaLabel: 'Northwestern Mutual Financial Planning',
        },
        {
          pageName: 'College Savings Plans',
          linkUrl: '/college-savings-plans/',
          linkAriaLabel: 'Northwestern Mutual College Savings Plans',
        },
      ]}
      disclaimerFootnotes={[
        <>
          {RankingNmInvestmentsServices(1)}
        </>,
        <>
          {LoyaltyBasedOnClientData(2)}
        </>,
      ]}
      customDisclaimers={[
        <>
          This is for information and educational purposes only and should not be interpreted as financial advice or investment recommendation. This is not intended as legal or tax advice. Northwestern Mutual Financial Representatives or Advisors do not render tax advice. Consult with a tax professional for tax advice that is specific to your situation. The primary purpose of permanent life insurance is to provide a death benefit. Using permanent life insurance accumulated value to supplement funding for education will reduce the death benefit and may affect other aspects of the policy. Utilizing the accumulated value through policy loans, surrenders, or cash withdrawals will reduce the death benefit&#59; and may necessitate greater outlay than anticipated and&#47;or result in an unexpected taxable event. All investments carry some level of risk including the potential loss of all money invested.
        </>,
      ]}>
      <Head>
        {/* prefetch expensive images */}
        <link rel='preload' href={highResMobileImage} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImage} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
      </Head>

      <Metadata
        image={highResDesktopImage}
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <HeroSection />

      <IntroSection />

      <HelpYouPlanSection />

      <Faq />

      <FinancialPlanningSection />

      <CredentialCalloutGrouping />

      <ContentHub
        sectionId='content-hub'
        backgroundVariant='lightC'
        headingText='Boost your knowledge on college savings plans'
        contentHubItems={contentHubItems} // defined in route.js
        config={config}
      />

      <AdvisorConnectModule />

    </Page>
  );
};
